import { AppContext } from 'vue'
import { Banner } from './banner'
import type { RewardedBanner } from './rewarded-banner'
import type { PlatformType } from '@/types'

export type BannerEventType = 'closed' | 'rewarded' | 'empty' | 'ready' | 'rendered' | 'viewable'

// TODO: type callback return type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type BannerEventListenerArgs = [type: BannerEventType, callback: (event: Event) => any]

export type PageAdType =
    | 'sidebar'
    | 'sidebar_bottom'
    | 'sticky_portrait'
    | 'sticky_mobile'
    | 'leaderboard'
    | 'catalog_mobile'
    // widget page ad slots
    | 'widget_sidebar'
    | 'widget_sidebar_bottom'
    | 'widget_horizontal'
    | 'widget_horizontal_2'
    | 'widget_sticky_mobile'

export type OutOfPageAdType = 'fullscreen' | 'interstitial' | 'interstitial_preroll' | 'rewarded' | 'sticky_portrait' // might be static and out-of-page

// we track these ad shows to send key conversion to optimize our own Ad compaigns
export const KEY_CONVERSION_AD_SHOW_TYPES: OutOfPageAdType[] = ['interstitial', 'interstitial_preroll', 'rewarded']

export enum AdProviderStatus {
    loading = 'loading',
    online = 'online',
    offline = 'offline',
}

export enum AdvActionFromMessage {
    preloadRewarded = 'preloadRewarded',
    showRewarded = 'showRewarded',
    preloadInterstitial = 'preloadInterstitial',
    showInterstitial = 'showInterstitial',
}

// manual call, not from game messages
export const showInterstitialPreroll = 'showInterstitialPreroll'

export type AdvAction = AdvActionFromMessage | typeof showInterstitialPreroll

export type PageAdSize = 'fluid' | [number, number]

export type PageAdOptions = {
    el?: string // id of element where to mount the ad
    sizes?: PageAdSize[]
    type: PageAdType
    refresh?: number // seconds
    clid?: string
    gameId?: string
    userId?: string
}

export type ManualAdOptions = Omit<PageAdOptions, 'type'> & {
    type: PageAdType | OutOfPageAdType
}

export type AdvServiceConfig = {
    targeting?: Record<string, string | string[]>
    platform: PlatformType
    vueAppContext: AppContext | undefined
}

export abstract class AdvService {
    abstract readonly serviceStatus: Promise<AdProviderStatus>

    abstract prepareOutOfPageAd(type: OutOfPageAdType, timeout?: number): Promise<RewardedBanner>

    abstract requestPageAd(options: PageAdOptions): Promise<Banner>

    abstract updateTargeting(targeting: AdvServiceConfig['targeting']): void
    abstract preloadIntroAds(): void
}
